import { UserProfileMutations } from './partials/user-profile'

export const UserMutations = {
  ...UserProfileMutations,
}
